import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorMessage } from 'app/core/error-handler/constants';
import { Error } from 'app/core/error-handler/models';
import { createErrorRaised } from 'app/core/error-handler/state/actions';
import { LanguageRestConnectorService } from 'app/core/language/services/language-rest-connector.service';
import {
  LanguageActionType,
  LoadLanguages,
  LoadLanguagesCompleted,
} from 'app/core/language/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class LanguageEffects {
  public source: string = 'LanguageEffects';

  /**
   * Load all available languages for a user.
   */
  @Effect()
  public loadLanguages$: Observable<Action> = this.actions$
    .pipe(
      ofType(LanguageActionType.LoadLanguages),
      map((action: LoadLanguages) => action.payload),
      switchMap(() => {
        return this._languageConnector.loadLanguages().pipe(
          map((language: {[key: string]: string}) => new LoadLanguagesCompleted(language)),
          catchError((err: any) => of(createErrorRaised(new Error({
            message: ErrorMessage.unexpected,
            errorResponse: err,
            source: this.source,
          })))),
        );
      }));

  constructor(private readonly actions$: Actions, private readonly _languageConnector: LanguageRestConnectorService) {}

}
